import React from "react";
import {FaLifeRing, FaRocket, FaCheckCircle, FaProjectDiagram} from "react-icons/fa";
import {FaChartSimple, FaDiagramProject, FaListCheck, FaScrewdriverWrench} from "react-icons/fa6";

const Step = ({ n, title, text }) => (
  <div className="approach-step">
    <div className="approach-step-num">{n}</div>
    <div>
      <div className="approach-step-title">{title}</div>
      <div className="approach-step-text">{text}</div>
    </div>
  </div>
);

export default function OperationalApproach() {
  return (
    <section id="approach" className="approach-section">
      <div className="container py-5">
        <div className="text-center mb-4">
          <h2 className="text-uppercase">How I work</h2>
          <p className="text-muted mb-0">
            Practical steps to stabilize and improve your backend without risky rewrites.
          </p>
        </div>

        <div className="approach-grid">
          <div className="approach-card">
            <div className="approach-title-row">
              <FaLifeRing className="approach-title-icon" aria-hidden="true" />
              <h3 className="approach-card-title">Stabilize live systems</h3>
            </div>
            <p className="text-muted mb-3">
              I focus on the issues that create real business impact first: outages, slowdowns and recurring incidents.
            </p>

            <Step n="1" title="Understand fast" text="Map the critical flow, key dependencies and current risk points." />
            <Step
              n="2"
              title="Fix what hurts most"
              text="Prioritize the problems that reduce incidents and customer impact first."
            />
            <Step n="3" title="Improve safely" text="Ship small, measurable fixes with clear rollback options." />
            <Step
              n="4"
              title="Keep it stable"
              text="Improve monitoring, alerts and runbooks so teams recover faster."
            />
          </div>

          <div className="approach-card accent">
            <div className="approach-title-row">
              <FaRocket className="approach-title-icon" aria-hidden="true" />
              <h3 className="approach-card-title">Build new services safely</h3>
            </div>
            <p className="text-muted mb-3">
              New services are built for production from day one, so scaling and operations stay predictable.
            </p>

            <Step n="1" title="Set clear scope" text="Define ownership, interfaces and data boundaries." />
            <Step
              n="2"
              title="Deliver first end-to-end flow"
              text="Release one complete workflow early to reduce delivery risk."
            />
            <Step
              n="3"
              title="Add production basics"
              text="Set up CI/CD, logs, metrics and dashboards from the start."
            />
            <Step
              n="4"
              title="Scale with evidence"
              text="Use load tests and production metrics to guide next improvements."
            />
          </div>
        </div>

        <div className="approach-callout">
          <div className="callout-title-row">

            <div className="callout-title">First days on your system</div>
          </div>
          <div className="callout-grid">
            <div><FaDiagramProject  className="callout-title-icon" aria-hidden="true"  style={{marginRight:"4px"}} /> Identification of the most fragile production flows</div>
            <div><FaScrewdriverWrench  className="callout-title-icon" aria-hidden="true" style={{marginRight:"4px"}}/>Immediate fixes for highest-risk issues</div>
            <div><FaListCheck  className="callout-title-icon" aria-hidden="true" style={{marginRight:"4px"}} />Clear stabilization priorities</div>
            <div><FaChartSimple  className="callout-title-icon" aria-hidden="true" style={{marginRight:"4px"}}/>Better monitoring and alert signals</div>
          </div>
        </div>
      </div>
    </section>
  );
}
